<template>
  <div class="search">
    <div class="result-box">
      <div class="title">
        医生约<span style="color:#FF0018">{{ doctorTotal }}个</span>结果
      </div>
      <div class="card-box">
        <div
          class="info-box"
          v-for="(item, index) in doctors"
          :key="index"
          @click="goNext('doc', item.id)"
        >
          <div class="left-box">
            <div class="hospitalImg hp_center">
              <img v-if="item.avatar" :src="base_url + item.avatar" alt />
              <img v-else src="@/assets/default-img/doctor.png" alt />
            </div>
          </div>
          <div class="right-box">
            <div style="margin-bottom:10px">
              <span class="name" style="color:#333333;margin-right:10px">
                {{ item.name }}
              </span>
              <span style="color:#666666">{{ item.title }}</span>
            </div>
            <div>{{ item.hospitalName }} {{ item.deptName }}</div>
          </div>
        </div>
      </div>
      <div
        class="seeMore cursor-point"
        v-if="doctorTotal > 4 && doctors.length == 4"
        @click="getMore('doc')"
      >
        查看更多
        <icon-font type="icon-xiala" />
      </div>
    </div>

    <div class="result-box">
      <div class="title">
        医院约<span style="color:#FF0018">{{ hospitalTotal }}个</span>结果
      </div>
      <div class="card-box">
        <div
          class="info-box"
          v-for="(item, index) in hospitals"
          :key="index"
          @click="goNext('hosp', item.id)"
        >
          <div class="left-box">
            <div class="hospitalImg hp_center">
              <img v-if="item.image" :src="base_url + item.image" alt />
              <img v-else src="@/assets/default-img/hospital.png" alt />
            </div>
          </div>
          <div class="right-box">{{ item.name }}</div>
        </div>
      </div>
      <div
        class="seeMore cursor-point"
        v-if="hospitalTotal > 4 && hospitals.length == 4"
        @click="getMore('hosp')"
      >
        查看更多
        <icon-font type="icon-xiala" />
      </div>
    </div>

    <div class="result-box">
      <div class="title">
        科室约<span style="color:#FF0018">{{ deptTotal }}个</span>结果
      </div>
      <div class="card-box">
        <div
          class="info-box"
          v-for="(item, index) in depts"
          :key="index"
          @click="goNext('dept', item.id)"
        >
          <div class="left-box">
            <div class="hospitalImg hp_center">
              <img v-if="item.image" :src="base_url + item.image" alt />
              <img v-else src="@/assets/default-img/dept.png" alt />
            </div>
          </div>
          <div class="right-box">{{ item.name }}</div>
        </div>
      </div>
      <div
        class="seeMore cursor-point"
        v-if="deptTotal > 4 && depts.length == 4"
        @click="getMore('dept')"
      >
        查看更多
        <icon-font type="icon-xiala" />
      </div>
    </div>
  </div>
</template>
<script>
import { getDoctors, getHospitals, getDepts } from '@/api/index'
export default {
  data() {
    return {
      doctorForm: {
        pageNum: 1,
        pageSize: 4,
        name: '',
      },
      deptForm: {
        pageNum: 1,
        pageSize: 4,
        name: '',
      },
      hospForm: {
        pageNum: 1,
        pageSize: 4,
        name: '',
      },
      doctors: [],
      doctorTotal: 0,
      hospitals: [],
      hospitalTotal: 0,
      depts: [],
      deptTotal: 0,
    }
  },
  created() {
    this.doctorForm.name = this.$route.query.keyWord
    this.deptForm.name = this.$route.query.keyWord
    this.hospForm.name = this.$route.query.keyWord
    //初始化获取数据
    this.getData()
  },
  watch: {
    $route(to, from) {
      this.doctorForm.name = to.query.keyWord
      this.deptForm.name = to.query.keyWord
      this.hospForm.name = to.query.keyWord
      this.getData()
    },
  },
  methods: {
    async getData() {
      //获取医生列表
      let doctorData = await getDoctors(this.doctorForm)
      this.doctors = doctorData.data.list || []
      this.doctorTotal = doctorData.data.totalCount
      //获取医院列表
      let hospitalData = await getHospitals(this.hospForm)
      this.hospitals = hospitalData.data.list || []
      this.hospitalTotal = hospitalData.data.totalCount
      //获取科室列表
      let deptData = await getDepts(this.deptForm)
      this.depts = deptData.data.list || []
      this.deptTotal = deptData.data.totalCount
    },
    async getMore(data) {
      switch (data) {
        case 'doc':
          this.doctorForm.pageSize = this.doctorTotal
          var docres = await getDoctors(this.doctorForm)
          this.doctors = docres.data.list
          break
        case 'hosp':
          this.hospForm.pageSize = this.hospitalTotal
          var hospres = await getHospitals(this.hospForm)
          this.hospitals = hospres.data.list
          break
        case 'dept':
          this.deptForm.pageSize = this.deptTotal
          var deptres = await getDepts(this.deptForm)
          this.depts = deptres.data.list
          break
        default:
          return '-'
      }
    },
    goNext(data, id) {
      switch (data) {
        case 'doc':
          this.$router.push('/registered/doctor/' + id + '/' + 0)
          break
        case 'hosp':
          this.$router.push('/registered/hospital/' + id)
          break
        case 'dept':
          this.$router.push('/registered/dept/' + id)
          break
        default:
          return '-'
      }
    },
  },
  mounted() {},
}
</script>
<style lang="less" scoped>
.search {
  width: 1200px;
  margin: 0 auto;
  padding: 0 30px;
  .result-box {
    .title {
      font-size: 21px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #3385ed;
    }
    .card-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .info-box {
        cursor: pointer;
        width: 518px;
        height: 100px;
        background: #ffffff;
        box-shadow: 0px 0px 6px 0px rgba(69, 157, 247, 0.19);
        border-radius: 10px;
        margin: 30px 0;
        padding: 20px;
        display: flex;
        align-items: center;
        .left-box {
          .hospitalImg {
            width: 62px;
            height: 62px;
            margin-right: 34px;
            overflow: hidden;
            border-radius: 50%;
            img {
              height: 62px;
            }
          }
        }
        .right-box {
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          div {
            font-size: 20px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999;
          }
        }
      }
    }
    .seeMore {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #3385ed;
      text-align: right;
    }
  }
}
</style>
